import { ContentSwitcher, Switch } from '@carbon/react';
import { LANGUAGES, useTranslation, type Language } from '@pos/i18n';

/** Choose the UI language; labels are each language's own name, so anyone can find theirs. */
export function LanguageSwitcher({ value, onChange }: { value: Language; onChange(language: Language): void }) {
  const { t } = useTranslation();
  return (
    <ContentSwitcher
      aria-label={t('common.language')}
      size="lg"
      selectedIndex={Math.max(0, LANGUAGES.findIndex((l) => l.code === value))}
      onChange={({ index }) => {
        const language = LANGUAGES[index ?? 0];
        if (language) onChange(language.code);
      }}
    >
      {LANGUAGES.map((language) => (
        <Switch key={language.code} name={language.code} text={language.label} />
      ))}
    </ContentSwitcher>
  );
}
